/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
export enum CheckInWizardStep {
  GET_STARTED = 'GET_STARTED',
  REVIEW_PREVIOUS_PRIORITIES = 'REVIEW_PREVIOUS_PRIORITIES',
  REVISIT_YOUR_BASELINES = 'REVISIT_YOUR_BASELINES',
  YOUR_ORG_MISSION_IMPACT = 'YOUR_ORG_MISSION_IMPACT',
  YOUR_ORG_HEALTH = 'YOUR_ORG_HEALTH',
  THANK_YOU = 'THANK_YOU',
}
